import { gql } from '@apollo/client';

export const ADD_UPDATE_REQUIRED_DOCUMENT = gql`
  mutation addOrUpdateRequiredDocument($input: RequiredDocumentItemInput) {
    addOrUpdateRequiredDocument(input: $input) {
      commandId
    }
  }
`;
